import { formatCurrency } from "@habity/utils";

export const getMonthlyFee = (fee: number | null, currency = "SEK") => {
  if (fee === null) return "";
  return `${formatCurrency(fee, currency)} / mån`;
};

// FIXME: Not properly currency formatted
// Need to figure out how to do range formatting gracefully
export function getMonthlyFeeRange(
  min: number | null,
  max: number | null,
) {
  if (min && max) {
    if (min === max) return `${formatCurrency(min)} / mån`
    return `${formatCurrency(min)} - ${formatCurrency(max)} / mån`
  }
  if (min) {
    return `Från ${formatCurrency(min)} / mån`
  }
  if (max) {
    return `Upp till ${formatCurrency(max)} / mån`
  }

  return "";
}
